<!--
 * @Descripttion:
 * @version: 优惠券-修改
 * @Author: Jeson
 * @Date: 2021-06-07 09:41:24
 * @LastEditors: Jerry
 * @LastEditTime: 2021-12-16 14:52:36
-->

<template>
  <div v-loading="loading">
    <!-- 我的优惠券 -->
    <div :style="{ paddingBottom: row ? '80px' : '0px' }">
      <van-row class="coupon-list" :gutter="isGet ? 24 : row ? 25 : 0">
        <van-col v-for="(item, index) in data" :key="index" :span="isGet ? 8 : row ? 12 : 24" class="i-col">
          <template v-if="type===1">
            <Coupon :item="item" :row="row" @handleDraw="handleDraw" @handleUse="handleUse" />
          </template>
          <template v-if="type===2">
            <CouponDts :item="item" :row="row" @handleDraw="handleDraw" @handleUse="handleUse" />
          </template>

        </van-col>
        <van-col v-if="row && data.length % 2 === 1" :span="12" class="i-col" />
        <van-col v-if="isGet && data.length % 3 === 1" :span="8" class="i-col" />
        <van-col v-if="isGet && data.length % 3 === 1" :span="8" class="i-col" />
        <van-col v-if="isGet && data.length % 3 === 2" :span="8" class="i-col" />
      </van-row>
    </div>

  </div>
</template>
<script>
import { BaseMixin } from '../mixins/BaseMixin.js'
import Coupon from './Coupon.vue'
import CouponDts from './CouponDts.vue'
export default {
  name: 'ICoupon',
  components: { Coupon, CouponDts },
  mixins: [BaseMixin],
  props: {
    data: {
      type: Array,
      default: () => []
    },
    // 是否领券中心
    isGet: {
      type: Boolean,
      default: false
    },
    page: {
      type: String,
      default: null
    },
    row: {
      type: Boolean,
      default: true
    },
    type: {
      type: Number,
      default: 1 // 1是默认 2是券包
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      receiveLoading: false
    }
  },
  methods: {
    // 立即领取
    async handleDraw(item) {
      const params = { couponPackageId: item.Id }
      this.receiveLoading = true
      item.loading = true
      const res = await this.postAction('/api_coupon/Coupon/SelfReceiveCoupons?couponPackageId=' + item.Id)
      item.loading = false
      this.receiveLoading = false
      // console.log("获取领取券数据", res.Data);
      if (res.IsSuccess && res.Data) {
        // 重新加载列表之前临时修改数据，保证按钮状态
        this.$emit('handleDraw')
        item.IsUse = false
        item.IsDestroy = false
        item.IsOverdue = false
        item.IsReceive = true
        this.$forceUpdate()
      } else {
        this.$toast.fail('领取失败\n' + res.Msg)
      }
    },
    // 立即使用
    handleUse(item) {
      if (this.page != 'ProductDetails') {
        this.$hys.openLoading()
        // if (item.Goods && item.Goods.length === 1) {
        //     this._jump(this.Enum_LinkTypeCode.ProductDetails, item.Goods[0].GoodsSkuId, '_blank');
        //     this.$hys.clearLoading();
        // } else if (item.Goods && item.Goods.length > 1) {
        //     this._jump(this.Enum_LinkTypeCode.ProductList, { ids: item.Goods.map((i) => { return i.GoodsSkuId }).join(',') }, '_blank')
        //     this.$hys.clearLoading();
        // } else {
        //     this._jump(this.Enum_LinkTypeCode.ProductList, null, '_blank');
        //     this.$hys.clearLoading();
        // }
        if (item.type == 1) {
          // 商品列表-全部商品
          this.$router.push({
            path: 'SearchPage',
            query: { nav: 'nav', couponIssueId: item.OutPackageIssueCouponDtos ? item.OutPackageIssueCouponDtos[0].CouponIssueId : item.CouponIssueId }
          })
        } else if (item.type == 2) {
          // 商品列表-非活动商品
          this.$router.push({
            path: 'SearchPage',
            query: { couponIssueId: item.OutPackageIssueCouponDtos ? item.OutPackageIssueCouponDtos[0].CouponIssueId : item.CouponIssueId }
          })
        } else if (item.type == 3) {
          // 商品列表-指定商城活动商品
          if (item.PrefectureId.length == 1 && item.ActivityList.length == 0) {
            // 跳转指定专区
            this.$router.push({ path: 'SpecialOffer', query: { id: item.PrefectureId[0] }})
          } else if (item.PrefectureId.length > 1) {
            // 跳转首页
            this.$router.push({ path: '/' })
          } else if (item.PrefectureId.length == 0 && item.ActivityList.length > 0) {
            // 跳转商品列表-筛选商品
            this.$router.push({
              path: 'SearchPage',
              query: { couponIssueId: item.OutPackageIssueCouponDtos ? item.OutPackageIssueCouponDtos[0].CouponIssueId : item.CouponIssueId }
            })
          } else {
            // 既有商品活动、和专区时跳转首页
            this.$router.push({ path: '/' })
          }
          this.$hys.clearLoading()
        } else if (item.type == 4) {
          // 商品券-多商品
          this.$router.push({
            path: 'SearchPage',
            query: { couponIssueId: item.OutPackageIssueCouponDtos ? item.OutPackageIssueCouponDtos[0].CouponIssueId : item.CouponIssueId }
          })
        } else if (item.type == 5) {
          // 商品详情
          this.$router.push({
            path: 'ProductDetails',
            query: { goodsId: item.Goods[0].GoodsSkuId }
          })
          this.$hys.clearLoading()
        }
      } else {
        this.$emit('handleUse', item)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.coupon-list {
  // /deep/.van-col.i-col:nth-child(odd) {
  // 	padding-right: 10px;
  // }

  // /deep/.van-col.i-col:nth-child(even) {
  // 	padding-left: 10px;
  // }
}
</style>
